// extracted by mini-css-extract-plugin
module.exports = {"varTextSubtle":"var(--tkww-union-color-text-subtle, var(--tkww-union-color-neutral-500, #51545C))","legalDisclosure":"legalDisclosure--d9ba0"};